import { message } from 'antd';

import { Logger, StandardLogger } from '@suntex.core/logging';

export function showErrorMessage(
  customerMessage: string,
  error: unknown,
  { logger }: { logger?: StandardLogger } = {},
) {
  (logger ?? Logger.global()).error(customerMessage, {}, error);
  message.error(customerMessage);
}

export function dismissAllMessages() {
  message.destroy();
}
